module.exports = __webpack_public_path__ + "static/media/arrow-right-blue.7ab54ae4.svg";


//////////////////
// WEBPACK FOOTER
// ./app/web/src/img/arrow-right-blue.svg
// module id = 117
// module chunks = 0